import React from 'react';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import ReactMarkdown from 'react-markdown';

const MarkdownStyled = styled(ReactMarkdown)`
  line-height: 30px;
  em {
    color: ${(props) => props.theme.mainBrandColor} !important;
  }
`;

const Markdown = ({ children, className }) => (
  <MarkdownStyled className={`content ${className}`}>{children}</MarkdownStyled>
);

Markdown.propTypes = {
  children: PropTypes.string,
  className: PropTypes.string,
};

Markdown.defaultProps = {
  children: '',
  className: '',
};

export default Markdown;
